import { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import Table from "react-bootstrap/Table";
import Sidebar from "../../components/Sidebar";
import { RiEyeLine } from "react-icons/ri";
import Loader from "../../components/Loader";
import { ProfileContext } from "../../context/ProfileContext";

function DiagnosticsCenterManagement() {
  const navigate = useNavigate();
  const { diagnosticsCenter, diagnosticsCenterPagination, getCenters } = useContext(ProfileContext)
  const [isLoading, setIsLoading] = useState(false);

  const getPaginationText = () => {
    if (!diagnosticsCenterPagination || diagnosticsCenterPagination.totalCount === 0) { return }
    const start = (diagnosticsCenterPagination.currentPage - 1) * diagnosticsCenterPagination.limit + 1;
    const end = Math.min(diagnosticsCenterPagination.currentPage * diagnosticsCenterPagination.limit, diagnosticsCenterPagination.totalCount);
    return `${start}-${end} of ${diagnosticsCenterPagination.totalCount} items`;
  };

  const handleNext = () => {
    if (diagnosticsCenterPagination && diagnosticsCenterPagination.currentPage < diagnosticsCenterPagination.totalPages) {
      setIsLoading(true);
      getCenters(diagnosticsCenterPagination.currentPage + 1);
    }
  };

  const handlePrevious = () => {
    if (diagnosticsCenterPagination && diagnosticsCenterPagination.currentPage > 1) {
      setIsLoading(true);
      getCenters(diagnosticsCenterPagination.currentPage - 1);
    }
  };

  return (
    <>
      <Loader isLoading={isLoading} />
      <div className="container-fluid">
        <Header />
        <div className="row">
          <Sidebar />
          <div className="col-9 main-dash-left">
            <section className="back-dashboard-sec comn-dashboard-page">
              <div className="notifi-list d-flex">
                <div>
                  <h6 className="comm_page_heading">Diagnostics Center Management</h6>
                  <p className="comm_page_sub_heading">
                    Receive AI-driven diagnostic suggestions based on consultation
                    data, helping guide accurate and timely treatment decisions
                  </p>
                </div>


                <div className="modal_pair_btns patient_referral_btns ">
                  <button className='main-btn' onClick={() => navigate('/add-diagnostic-center')}>Add Center</button>
                </div>
              </div>

              <div className="comm-table pt-0 refferal_table_outer">
                <Table>
                  <thead>
                    <tr className="head-class-td">
                      <th>Sr. no.</th>
                      <th>Center Name</th>
                      <th>Email</th>
                      <th>Contact no.</th>
                      <th>Address</th>
                      <th width="10%">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {diagnosticsCenter && diagnosticsCenter.length > 0 ?
                      diagnosticsCenter.map((item, index) => {
                        return (
                          <tr key={index}>
                            <td>{(diagnosticsCenterPagination.currentPage - 1) * diagnosticsCenterPagination.limit + index + 1}</td>
                            <td>{item?.center_name}</td>
                            <td>{item?.email}</td>
                            <td>{item?.contact_number}</td>
                            <td>{item?.address}</td>
                            <td><Link className="table-view-btn" to="/view-diagnostic-center" state={item}><RiEyeLine /></Link></td>
                          </tr>
                        )
                      })
                      :
                      <tr><td colSpan={6}>No centers added yet!</td></tr>
                    }
                  </tbody>

                </Table>
              </div>
              {diagnosticsCenterPagination && diagnosticsCenterPagination.totalCount > 10 &&
                <div className="d-flex table_bottom_row">
                  <h4 className="page_count_txt">{getPaginationText()}</h4>
                  <div className="d-flex btn_grp">
                    <button className="table_bott_btn" onClick={handlePrevious} disabled={!diagnosticsCenterPagination || diagnosticsCenterPagination.currentPage <= 1}>Previous</button>
                    <button className="table_bott_btn" onClick={handleNext} disabled={!diagnosticsCenterPagination || diagnosticsCenterPagination.currentPage >= diagnosticsCenterPagination.totalPages}>Next</button>
                  </div>
                </div>
              }
            </section>
          </div>
        </div>
      </div>
    </>
  );
}

export default DiagnosticsCenterManagement;
